import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import { trackRatingClick } from './tracking';

import * as styles from './Title.css';

interface ITitleProps {
  linkHref: string | null;
  text: string;
}

export const Title: React.FunctionComponent<ITitleProps> = ({ linkHref, text }) => (
  <div className={styles['container']}>
    <ArticleHeading1 as="h1">{text}</ArticleHeading1>
    {linkHref && (
      <a
        href={linkHref}
        onClick={trackRatingClick}
        className={styles['link']}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ArticleParagraph1 color="primary_100">Ежемесячный рейтинг профессионалов ↗</ArticleParagraph1>
      </a>
    )}
  </div>
);
